module.exports = __webpack_public_path__ + "assets/img/report-suc.8c013255.png";